<template>
    <div>
        <div class="box">
            <label v-if="typeof labelText !== 'undefined'">{{labelText}}</label>
            <div class="radio-box" v-for="(item) in data.data" :key="item.id" :value="value"
                 @click="onClickDiv(item.id, item.value)">
                <input class="radio-hidden" type="radio" :name="item.name" :id="item.id" :value="item.value"
                       v-on:change="onChangeEvent" v-model="data.checked"
                />
                <div class="radio" tabindex="0">
                    <div class="radio-checked"></div>
                </div>
                <label :for="item.id" style="margin: 0 10px;width: auto;">{{item.label}}</label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BBtnRadio",
        props: {
            value: Object,
            labelText: String,
        },
        data() {
            return {
                data: null,
            }
        },
        methods: {
            onClickDiv(id, value) {
                document.getElementById(id).checked = true;
                this.data.checked = value;
                this.$emit("input", this.data)
            },
            onChangeEvent() {
                this.$emit("input", this.data)
            }
        },
        created() {
            this.data = this.value;
        }
    }
</script>

<style scoped>

    *{
        outline: none;
    }

    label {
        /* margin: 0 10px; */
        margin: 0px 10px 0 20px;
        width: 60px;
        font-size: 14px;
        color: #333333;
        text-align: right;
    }

    .box{
        display: flex;
    }

    .radio-box {
        display: flex;
        align-items: center;
    }

    .radio-hidden {
        display: none;
    }

    .radio-hidden:checked + div div {
        display: block;
    }

    .radio {
        width: 17px;
        height: 17px;
        background: #FFFFFF;
        border: 1px solid #0171A3;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .radio:hover,
    .radio:focus {
        box-shadow: 0 0 4px #2196f3;
    }

    .radio-checked {
        width: 9px;
        height: 9px;
        background: #0171A3;
        border-radius: 50%;
        display: none;
    }

</style>